import React from 'react';
import { HeroCanvas } from './HeroCanvas';
import { ChannelsArt } from './illustrations';

/**
 * The /use-cases hero.
 *
 * Fourth page on the shared canvas, carrying the old PageHero's copy
 * unchanged. The object on the panel is the one thing that varies between
 * them — home has the phone, /features the dashboard, /pricing the savings
 * scene, and this one the channel mesh: the WASLX mark at the hub with
 * WhatsApp, Facebook, Instagram, Android and SIP wired into it. That is
 * the page's whole argument — one platform, whichever channel the leads
 * and calls arrive on.
 */
const UseCasesHero = () => (
  <HeroCanvas>
    <div className="grid items-center gap-14 lg:grid-cols-[1.15fr_0.85fr] lg:gap-10">
      <div>
        <span className="eyebrow accent-5 animate-fade-up">
          <span className="spark-mark" aria-hidden="true" />
          Use cases
        </span>

        <h1 className="display-heading mt-6 animate-fade-up" style={{ animationDelay: '70ms' }}>
          <span className="display-solid block">Built for your</span>
          <span className="display-accent block">industry</span>
        </h1>

        <p
          className="mt-6 max-w-xl text-lede leading-relaxed text-content-muted animate-fade-up"
          style={{ animationDelay: '140ms' }}
        >
          Whether you run a 200-seat BPO or a five-person sales team, WASLX fits how your team
          actually works — on Android, on the go.
        </p>
      </div>

      {/* .accent-6 for the same reason the other heroes reach for a cool
          accent: the art draws in --accent / --accent-alt on a blue→violet
          panel, and a warm hue there fights its own ground. */}
      <div className="accent-6 flex animate-fade-in justify-center" style={{ animationDelay: '180ms' }}>
        <ChannelsArt className="h-auto w-full max-w-md" />
      </div>
    </div>
  </HeroCanvas>
);

export default UseCasesHero;
